var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7875 18.8826C22.4569 19.5522 22.4569 20.638 21.7875 21.3077C21.118 21.9773 20.0326 21.9773 19.3631 21.3077L11.64 13.5823L3.6711 21.5536C3.00163 22.2232 1.9162 22.2232 1.24673 21.5536C0.577261 20.8839 0.577262 19.7982 1.24673 19.1285L9.21565 11.1572L1.28136 3.22055C0.611886 2.55088 0.611886 1.46513 1.28136 0.795465C1.95083 0.125796 3.03625 0.125795 3.70572 0.795465L11.64 8.73211L19.3285 1.04138C19.9979 0.37171 21.0834 0.37171 21.7528 1.04138C22.4223 1.71105 22.4223 2.7968 21.7528 3.46647L14.0644 11.1572L21.7875 18.8826Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8295ecd6d7445352e4c0350c555c56db.svg";
export { ForwardRef as ReactComponent };